import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { Link, NavLink, Outlet, useParams } from "react-router-dom";
import { API_GET_PROBLEM, API_URL } from "../../../../services/ApiEndpoints";
import authHeader from "../../../../services/auth-header";
import TransPopup from "../../../libs/TransPopup";
import { print_idea_status, print_problem_status } from "../../Consts";

const MyProblemView = () =>{

    let {slug} = useParams();
    const [isLoading, setIsLoading] = useState(false)

    const [data, setData] = useState({})

    const getDetails = () =>{

        setIsLoading(true)

        axios
        .get(API_URL + API_GET_PROBLEM +"/"+ slug,{
            headers: authHeader()
        })
        .then((response)=>{
            
            if(response.status==200){

                const json = response.data;

                if(json.status=="RC200"){

                    var data = json.data;

                    setData(data)

                }

            }

            setIsLoading(false)

        })
        .catch((error)=>{
            setIsLoading(false)
        });

    }

    useEffect(()=>{
        getDetails()
    }, [])

    const [allowReload, setAllowReload] = useState(0)

    useEffect(()=>{
        getDetails()
    }, [allowReload])
    
    return(
        <section>
            <div className="gap gray-bg">
                <div className="container">
                    
                    { isLoading ? (<p>Loading...</p>) : (
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="row merged20" id="page-contents">
                                    <div className="col-md-12">
                                        <div className="central-meta">
                                            
                                            <div className="row">
                                                <div className="col-md-9">
                                                    <h3>{data.pain_point}</h3>
                                                </div>
                                                
                                            </div>

                                            <h6 style={{"color":"#f05a24"}} className="mb-3">{data.unique_id}</h6>
                                            
                                            <em>Created at: {data.date}</em><br />
                                            <em>Last Updated: {data.date_updated}</em><br />

                                            Status: &nbsp; {print_problem_status(data)}

                                            <div className="frnds mt-4">
                                                <ul className="nav nav-tabs mb-2">
                                                    <li className="nav-item">
                                                        <NavLink to={"responses"} >Business Problem Responses</NavLink> <span>{data.total_offers}</span>
                                                    </li>
                                                    <li className="nav-item">
                                                        <NavLink to={"chat"} >Chat(s)</NavLink> <span>{data.total_chats}</span>
                                                    </li>
                                                    <li className="nav-item">
                                                        <NavLink to={"edit"} >Edit Business Problem Details</NavLink>
                                                    </li>
                                                    <li className="nav-item">
                                                        <NavLink to={"details"} >Business Problem Details</NavLink>
                                                    </li>
                                                </ul>

                                                <div className="gap gray-bg">
                                                    <div className="container">
                                                        <Outlet context={[allowReload, setAllowReload]} />
                                                    </div>
                                                </div>
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                </div>
            </div>
        </section>
    );
};


export default MyProblemView;